import * as THREE from 'three';

// Just hemisphere + sun. Extra directional lights cost shader cycles on every
// material; with a warm hemi the missing fill/rim aren't really missed.
export function createLights(sunDir) {
  const hemi = new THREE.HemisphereLight(0xffd6a0, 0x4d3a7c, 0.7);
  const sun = new THREE.DirectionalLight(0xffe2b6, 1.55);
  sun.position.copy(sunDir).multiplyScalar(800);
  return { hemi, sun };
}
